import { useNavigation, useTranslate } from "@refinedev/core";
import { useTable } from "@refinedev/antd";
import { Typography, Table, Avatar, Space, Tag } from "antd";
import {
    RecentOrdersColumn,
    Price,
    OrderId,
    Title,
    TitleWrapper,
} from "./styled";

import { OrderActions } from "components";

import { IGameusers } from "interfaces";

const { Text, Paragraph } = Typography;

export const NewGameUsers: React.FC = () => {
    const t = useTranslate();
    const { tableProps } = useTable<IGameusers>({
        resource: "gameusers",
        initialSorter: [
            {
                field: "createdAt",
                order: "desc",
            },
        ],
        initialPageSize: 4,
        permanentFilter: [
            {
                field: "gsm",
                operator: "eq",
                value: "Pending",
            },
        ],
        syncWithLocation: false,
    });

    const { show } = useNavigation();

    return (
        <Table
            {...tableProps}
            pagination={{ ...tableProps.pagination, simple: true }}
            showHeader={false}
            rowKey="id"
        >
            <Table.Column<IGameusers>
                key="avatar"
                render={(_, record) => (
                    <Avatar
                        size={{
                            xs: 60,
                            lg: 108,
                            xl: 132,
                            xxl: 144,
                        }}
                        src={record?.avatar[0]?.url}
                    />
                )}
            />
            <RecentOrdersColumn
                key="summary"
                render={(_, record) => (
                    <TitleWrapper>
                        {/* <Title strong>{record?.name}</Title> */}
                        <Title strong>{`UserInfo`}</Title>

                        <Paragraph
                            ellipsis={{
                                rows: 2,
                                tooltip: record?.address,
                                symbol: <span>...</span>,
                            }}
                        >
                            {/* {record?.userId} */}
                        </Paragraph>

                        <OrderId
                            strong
                            onClick={() => {
                                show("orders", record.userId);
                            }}
                        >
                            #{'userId'}
                            {/* {record?.userId} */}

                        </OrderId>
                    </TitleWrapper>
                )}
            />
            <RecentOrdersColumn
                key="summary"
                render={(_, record) => (
                    <Space direction="vertical">
                        <Title
                            strong
                        >{`username:${record.username}`}</Title>
                        <Text>{record.address}</Text>
                    </Space>
                )}
            />
            <RecentOrdersColumn
                key="summary"
                render={(_, record) => (
                    <Space direction="vertical">
                        <Title
                            strong
                        >{`gender:${record.gender}`}</Title>
                        <Text>{record.address}</Text>
                    </Space>
                )}
            />
            <Table.Column<IGameusers>
                dataIndex="amount"
                render={(value, record) => (
                    <Space
                        size="large"
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {/* <Price
                            strong
                            options={{
                                currency: "USD",
                                style: "currency",
                                notation: "standard",
                            }}
                            value={value / 100}
                        /> */}
                        <Tag color="orange">
                            {`${record.email}`}
                            {record?.avatar[0]?.url}
                        </Tag>
                    </Space>
                )}
            />
            {/* <Table.Column<IGameusers>
                fixed="right"
                key="actions"
                align="center"
                render={(_, record) => <OrderActions record={record} />}
            /> */}
        </Table>
    );
};
